export const VivaViolationDialog = ({
  message,
  count,
  max,
  onContinue,
}) => (
  <div
    style={{
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0,0,0,0.92)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 99999,
    }}
  >
    <div
      style={{
        background: "#fff",
        padding: "40px",
        borderRadius: "16px",
        maxWidth: "600px",
        textAlign: "center",
      }}
    >
      <h2 style={{ color: "#d32f2f" }}>⚠ Proctoring Violation</h2>

      <p>{message}</p>

      <p>
        <b>{count} / {max}</b>
      </p>

      <button onClick={onContinue}>
        Continue Assessment
      </button>
    </div>
  </div>
);
